import { ActionType, ProColumns } from '@ant-design/pro-components';
import { DatePicker, Form } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import { Filter } from 'base/ui/components/Icons';
import dayjs from 'dayjs';
import useDebounce from 'hooks/useDebounce';
import usePartialState from 'hooks/usePartialState';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { dropdownstatus } from 'pages/Components/dataDropDown';
import { SearchModel } from 'pages/model';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonModel } from 'services/Main/common_services';
import { WorkStatusReportModel } from 'services/Main/reportVisitCustomerSR';
import { commonPresenter, commonStore, reportVisitCustomerSRPresenter, reportVisitCustomerSRStore, uiStore } from 'stores/root_store';
import { DATE_FORMAT_DEFAULT, DATE_FORMAT_POST, PAGE_SIZE_DEFAULT } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { getPlantCode } from 'utils/localStorageHelper';


const { RangePicker } = DatePicker;

// BÁO CÁO TRẠNG THÁI CÔNG VIỆC NVKT
// báo cáo trạng thái công việc nhân viên kỹ thuật
const createWorkStatusReport = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const tableRef = useRef<ActionType>();
    const columns = [
      // stt
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        width: 60,
        align: 'center',
      },
      // Nhân viên kỹ thuật
      {
        title: 'Nhân viên kỹ thuật',
        dataIndex: 'employeeName',
        key: 'employeeName',
        width: 200,
        fixed: 'left',
        ellipsis: true
      },
      // Đang thực hiện
      {
        title: 'Đang thực hiện',
        dataIndex: 'dangThucHien',
        key: 'dangThucHien',
        children: [
          // Bảo hành
          {

            title: 'Bảo hành',
            dataIndex: 'baoHanh',
            key: 'baoHanh',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.baoHanh, 0)}</>),
            width: 100,
          },
          // Lắp đặt
          {

            title: 'Lắp đặt',
            dataIndex: 'lapDat',
            key: 'lapDat',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.lapDat, 0)}</>),
            width: 100,
          },
          // Khảo sát
          {

            title: 'Khảo sát',
            dataIndex: 'khaoSat',
            key: 'khaoSat',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.khaoSat, 0)}</>),
            width: 100,
          },
          // HDSD
          {

            title: 'HDSD',
            dataIndex: 'hdsd',
            key: 'hdsd',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.hdsd, 0)}</>),
            width: 100,
          },
          // LĐ công trình
          {

            title: 'LĐ công trình',
            dataIndex: 'ldCongTrinh',
            key: 'ldCongTrinh',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.ldCongTrinh, 0)}</>),
            width: 100,
          },
          // LĐ Trưng bày
          {

            title: 'LĐ Trưng bày',
            dataIndex: 'ldTrungBay',
            key: 'ldTrungBay',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.ldTrungBay, 0)}</>),
            width: 100,
          },
          // Gỡ hàng TB
          {

            title: 'Gỡ hàng TB',
            dataIndex: 'goHangTB',
            key: 'goHangTB',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.goHangTB, 0)}</>),
            width: 100,
          },
          // CSKH ĐB
          {

            title: 'CSKH ĐB',
            dataIndex: 'cskhDacBiet',
            key: 'cskhDacBiet',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.cskhDacBiet, 0)}</>),
            width: 100,
          },
          // Tổng
          {

            title: 'Tổng',
            dataIndex: 'tong',
            key: 'tong',
            align: 'right',
            render: (_, record) => (<>{formatNumber(record.tong, 0)}</>),
            width: 100,
          }
        ]
      },
      // Đã hoàn thành
      {
        title: 'Đã hoàn thành',
        dataIndex: 'daHoanThanh',
        key: 'daHoanThanh',
        align: 'right',
        render: (_, record) => (<>{formatNumber(record.daHoanThanh, 0)}</>),
        width: 100,
      },
      // Tổng lịch
      {
        title: 'Tổng lịch',
        dataIndex: 'tongLich',
        key: 'tongLich',
        align: 'right',
        render: (_, record) => (<>{formatNumber(record.tongLich, 0)}</>),
        width: 100,
      },


    ] as ProColumns[]

    //----------------------------------------- DATA TABLE ------------------------------------------
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      companyCode: "1000",
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
    });

    // disable rangePicker khi chọn ngày từ common
    const [loading, setLoading] = usePartialState({
      loadingSearch: false,
      loading: false,
    })


    const [open, setOpen] = usePartialState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    // Công ty
    const [listCompany, setListCompany] = useState<CommonModel[]>([]);
    // bảo hành
    const [listWarranty, setListWarranty] = useState<CommonModel[]>([]);
    // Phòng ban
    const [listDepartment, setListDepartment] = useState<CommonModel[]>([]);
    // nhân viên
    const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
    const [dataReport, setDataReport] = useState<WorkStatusReportModel[]>([])


    // -------------------------------------------------------------------------------------------------
    // -------------------------------------------------------------------------------------------------
    // -------------------------------------------------------------------------------------------------
    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };

    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccount(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };

    // Lấy danh sách người tạo
    const getListCreateBy = async (key = '') => {
      await commonPresenter.getListPersonInCharge(commonStore, key);
      if (commonStore.commonRespone.isSuccess) {
        setListCreateBy(commonStore.commonRespone.data);
      }
    };
    const searchCreateBy = useDebounce(getListCreateBy, 500);

    // Phòng ban
    const getDataDepartment = async (company?: string, role?: string) => {
      await commonPresenter.getListRole(commonStore, role, company);
      if (commonStore.commonRespone.isSuccess) {
        setListDepartment(commonStore.commonRespone.data);
      }
    };

    const getDropdownWarranty = async (key = '') => {
      await commonPresenter.getCommonDataByKey(commonStore, "ServiceTechnicalTeam");
      if (commonStore.commonRespone.isSuccess) {
        setListWarranty(commonStore.commonRespone.data)
      }
    }
    const debounceSearchWarranty = useDebounce(getDropdownWarranty, 300);

    //================================================================================================
    //================================================================================================
    //================================================================================================
    useEffect(() => {
      (async () => {
        getDataCompany()
        debounceSearchWarranty()
        // lấy phòng ban dựa theo công ty
        getDataDepartment(getPlantCode())
        searchCreateBy()
      })()
    }, [])


    // lấy data báo cáo =============================================================================
    const getDataReport = async (dataSearch: object) => {
      await reportVisitCustomerSRPresenter.getWorkStatusReport(reportVisitCustomerSRStore, dataSearch);
      if (reportVisitCustomerSRStore.workStatusRP.isSuccess) {
        const dataTemp = cloneDeep(reportVisitCustomerSRStore.workStatusRP.data);

        setDataReport(dataTemp);
        return dataTemp;
      }
      setDataReport([]);
      return [];
    }


    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.report-work-status'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        <BoxContainer>
          <CustomProTable
            bordered
            columns={columns}
            dataSource={dataReport}
            rowKey={'stt'}
            actionRef={tableRef}
            scroll={{ x: 1600, y: 500 }}
            request={async (params = {}, sort, filter) => {
              let data: WorkStatusReportModel[] = [];
              data = await getDataReport(dataSearch);
              return {
                data: data,
                success: reportVisitCustomerSRStore.workStatusRP.isSuccess,
              };
            }}

            pagination={{
              ...tablePagination(dataSearch, setDataSearch),
              total: reportVisitCustomerSRStore.workStatusRP.paging?.totalCount,
            }}
            options={false}

            toolBarRender={() => [
              // EXPORT =================================================================
              <CustomButton
                loading={loading.loading}
                onClick={async () => {
                  setLoading({ loading: true });
                  const { paging, ...rest } = dataSearch
                  await reportVisitCustomerSRPresenter.exportExcelWorkStatus({ ...rest, lang: uiStore.language })
                  setLoading({ loading: false });
                }}
                icon={<Icon.Download className={'!fill-dark'} />}
              >
                {t('btn.export')}
              </CustomButton>]}
          />
        </BoxContainer>

        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[25%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              loading={loading.loadingSearch}
              type="primary"
              onClick={() => {
                const value = form.getFieldsValue()
                // Lọc ra các key có giá trị không phải là chuỗi rỗng hoặc mảng rỗng
                const tempt = Object.fromEntries(
                  Object.entries(value).filter(([key, value]) => value !== "" && !(Array.isArray(value) && value.length === 0))
                ) as any;
                setDataSearch({
                  ...tempt,
                  createDateFrom: tempt.createDate?.[0] ? dayjs(tempt.createDate?.[0])?.format(DATE_FORMAT_POST) : undefined,
                  createDateTo: tempt.createDate?.[1] ? dayjs(tempt.createDate?.[1])?.format(DATE_FORMAT_POST) : undefined,
                  startDateFrom: tempt.startDate?.[0] ? dayjs(tempt.startDate?.[0])?.format(DATE_FORMAT_POST) : undefined,
                  startDateTo: tempt.startDate?.[1] ? dayjs(tempt.startDate?.[1])?.format(DATE_FORMAT_POST) : undefined,
                  endDateFrom: tempt.endDate?.[0] ? dayjs(tempt.endDate?.[0])?.format(DATE_FORMAT_POST) : undefined,
                  endDateTo: tempt.endDate?.[1] ? dayjs(tempt.endDate?.[1])?.format(DATE_FORMAT_POST) : undefined,
                  receiveDateFrom: tempt.receiveDate?.[0] ? dayjs(tempt.receiveDate?.[0])?.format(DATE_FORMAT_POST) : undefined,
                  receiveDateTo: tempt.receiveDate?.[1] ? dayjs(tempt.receiveDate?.[1])?.format(DATE_FORMAT_POST) : undefined,
                  paging: {
                    pageIndex: 1,
                    pageSize: 10,
                  }
                });

                form.submit();
                tableRef.current?.reload();
                onClose();
              }}
            >
              {t('btn.search')}
            </CustomButton>
          }
        >
          <SearchForm
            form={form}
            onFinish={(value) => {
              tableRef.current?.reload();
            }}
            column="col-1"
            initialValues={{
              companyCode: getPlantCode()
            }}
          >
            {/* Công ty */}
            <SearchItem col2
              rules={[{ required: true }]}
              name={"companyCode"}
              label={"Công ty"}
            >
              <CustomSelect
                allowClear
                options={listCompany}
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                onChange={(value, option) => {
                  getDataDepartment(value)
                }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>
            {/* Trung tâm bảo hành */}
            <SearchItem col2
              name={"warrantyCode"}
              label={"Trung tâm bảo hành"}
            >
              <CustomSelect
                allowClear
                showSearch
                mode="multiple"
                filterOption={false}
                fieldNames={{ label: "value", value: "key" }}
                onBlur={async () => await debounceSearchWarranty()}
                options={listWarranty}
                onClear={() => debounceSearchWarranty()}
                onSearch={(value) => {
                  value ? debounceSearchWarranty(value) : debounceSearchWarranty()
                }}
              />
            </SearchItem>
            {/* Phòng ban */}
            <SearchItem
              name={"departmentCode"}
              label={t("search-form.department")}
              col2
            >
              <CustomSelect
                options={listDepartment}
                mode='multiple'
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Nhân viên được phân công */}
            <SearchItem name={'employeeCode'} label={'Nhân viên được phân công'} col2>
              <CustomSelect
                options={listCreateBy}
                mode='multiple'
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={false}
                onSearch={(value) => {
                  if (value) {
                    searchCreateBy(value);
                  } else {
                    searchCreateBy();
                  }
                }}
                onClear={() => searchCreateBy()}
                allowClear
                showSearch
              />
            </SearchItem>
            {/* Ngày tạo  */}
            <SearchItem name={"createDate"} label={"Ngày tạo"} start col2>
              <RangePicker placeholder={['Từ ngày', 'Đến ngày']} allowEmpty={[true, true]} className='!w-full' format={DATE_FORMAT_DEFAULT} />
            </SearchItem>
            {/* Ngày tiếp nhận  */}
            <SearchItem name={"receiveDate"} label={"Ngày tiếp nhận"} start col2>
              <RangePicker placeholder={['Từ ngày', 'Đến ngày']} allowEmpty={[true, true]} className='!w-full' format={DATE_FORMAT_DEFAULT} />
            </SearchItem>
            {/* Ngày bắt đầu */}
            <SearchItem name={"startDate"} label={"Ngày bắt đầu"} start col2>
              <RangePicker placeholder={['Từ ngày', 'Đến ngày']} allowEmpty={[true, true]} className='!w-full' format={DATE_FORMAT_DEFAULT} />
            </SearchItem>
            {/* Ngày kết thúc */}
            <SearchItem name={"endDate"} label={"Ngày Kết thúc"} start col2>
              <RangePicker placeholder={['Từ ngày', 'Đến ngày']} allowEmpty={[true, true]} className='!w-full' format={DATE_FORMAT_DEFAULT} />
            </SearchItem>
          </SearchForm>
        </SearchBox >
      </PageWrapper>
    )
  })
}

export default createWorkStatusReport